import { getCookie } from "./cookies";

const CSRF_URL = import.meta.env.VITE_BACKEND_URL + "/sanctum/csrf-cookie";

/**
 * Name of the cookie the backend issues the CSRF token in (its `XSRF_COOKIE_NAME`).
 * Environments that share a cookie domain each use their own name; everywhere else
 * it is Laravel's default.
 */
const xsrfCookieName = () =>
  import.meta.env.VITE_XSRF_COOKIE_NAME || "XSRF-TOKEN";

/** The CSRF token to send back in the `X-XSRF-TOKEN` header, if one was issued. */
export const getXsrfToken = () => getCookie(xsrfCookieName());

export const csrfRequest = async () => {
  const csrfResult = await fetch(CSRF_URL, {
    credentials: "include",
  });

  if (!csrfResult.ok) {
    throw new Error(`Response status: ${csrfResult.status}`);
  }
};
